import axios from "axios";
import React, { createContext, useEffect, useRef, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "./App.css";
import "./components/CSS/BodyColor.css";

//Auth
import AccountCreate from "./Screen/Auth/AccountCreate";

import Login from "./Screen/Auth/Login";
import Otp from "./Screen/Auth/Otp";
import Signup from "./Screen/Auth/Signup";
import Forget from "./Screen/Auth/Forget";

import AuditionDescription from "./components/Pages/AuditionPages/AuditionWithStar/AuditionWithStar";
import MasterLayout from "./components/Layouts/MasterLayout";
import VideoCall from "./VideoCall";
// Category
import CoreCategory from "./Screen/Category/CoreCategory";
import StarSelection from "./Screen/Category/StarSelection";

// Error
import Error from "./Screen/Error";

// Home Page
import Home from "./Screen/HomePages";
import Profile from "./Screen/Profile/Profile";
import StarProfile from "./Screen/Profile/StarProfile";
import GuestUserPage from "./Screen/GuestUserPage";
import Packages from "./Screen/Packages/Packages";
import SliderTutorial from "./Screen/TutorialSPage/SliderTutroial";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";

// Left Sidebar
// Souvenir
import { io } from "socket.io-client";

import CategoryModal from "./components/Modal/CategoryModal/CategoryModal";
import GreetingRegistration from "./components/Pages/GreetingRegistration/GreetingRegistration";

import NestedSubCategoryBody from "./components/Category/CategorySelector/NestedSubCategoryBody";
import SubCategorySelector from "./components/Category/CategorySelector/SubCategorySelectorBody";
import RegisterLearningDetails from "./components/RegisterLearningDetails/RegisterLearningDetails";

import VideoUploadAudition from "./components/Right/AuditionsPost/ParticipateGuitarChord/VideoUploadAudition";
import "./components/Pages/LearningPages/LearningSession/LearningSessionActivities.css";
import LiveChatDetails from "./components/Pages/LiveChat/LiveChatDetails";
import Shipping from "./Screen/MarketPlace/Shipping";
import MeetupDetails from "./components/Pages/Meetup/MeetupDetails";
import UserProfile from "./Screen/Profile/UserProfile";
import QnaDetails from "./components/Pages/Qna/QnaDetails";
import Auction from "./Screen/Auction/Auction";
import AcquiringProduct from "./Screen/Auction/AcquiringProduct";
import AuctionSignature from "./Screen/Auction/AuctionSignature";
import WinnerCR7 from "./Screen/Auction/WinnerCR7";
import SouvenirInvoice from "./Screen/Souvenir/Invoice/SouvenirInvoice";
import PurchaseInvoice from "./components/Layouts/Sidebar/Left/Activities/Content/PurchaseInvoice";
import StripePayment from "./components/Pages/StripPayment/StripePayment";

import LiveChatCall from "./LiveChatCall";
import Joinroomlogin from "./Screen/Auth/MobileView/JoinRoomLogin";
import TestPaginate from "./TestPaginate";
import LearningSessionLiveStream from "./VideoCall";
import VideoSdk from "./VideoSdk";
import { LocationContext } from "./CustomHelper/Helper";
import GuestMasterLayout from "./components/Layouts/GuestMasterLayout";
import FanGroupBody from "./components/Layouts/Sidebar/Left/FanGroup/FanGroupBody";
import Menu from "./components/Layouts/Header/Menu";
import AuditionGuitar from "./components/Right/AuditionsPost/AuditionGuitar";
import SubCategory from "./Screen/Category/SubCategory";
import SuryaPay from "./components/Payment/SuryaPay";
import SSLCommerzPay from "./components/Payment/sslCommerzPay";
import NewPassword from "./Screen/Auth/NewPassword";
import Ipay88 from "./components/Payment/Ipay88";
import moment from "moment";
import { publicIp, publicIpv4, publicIpv6 } from "public-ip";

import toast, { Toaster } from "react-hot-toast";
import swal from "sweetalert";

// import ip from "ip"
import { useTranslation } from "react-i18next";
import AccountDeleteRequest from "./Screen/AccountDeleteRequest";

import { generateToken, messaging } from "./notifications/firebase";
import { onMessage } from "firebase/messaging";
import About from "./Screen/Policy/About";
import GreetingsVideo from "./Screen/GreetingsVideo";
import ShareRedirect from "./Screen/ShareRedirect";

export const socketContext = createContext();
export const serverInfo = createContext();

/**
 * backend connection
 */

// const backendEngUrl = "http://10.10.10.188/HelloSuperStarsBackend/public";
//     const backendEngUrl = "https://apihss.textware.lk";

const backendEngUrl = "https://backend.hellosuperstars.com";
// const backendEngUrl = "http://10.10.10.159/backend/public/";
const socketEngUrl = "https://socket.hellosuperstars.com";
// const socketEngUrl = "http://10.10.10.134:3005";
// const domin = "http://localhost:3000/hss";
const domin = "https://hellosuperstars.com";

// Fan Group
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.baseURL = backendEngUrl + "/";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

function App() {
  useEffect(() => {
    generateToken();
    onMessage(messaging, (payload) => {});
  }, []);

  const [shurjoFrormData, setShurjoFrormData] = useState({});
  const [socketData, setSocketData] = useState();
  const [trackCurrencyValue, setTrackCurrencyValue] = useState(1);
  const [trackCurrencySymbol, setTrackCurrencySymbol] = useState("1");
  const [imageCdnUrl, setImageCdnUrl] = useState(
    "https://d35vkepp4dfq5y.cloudfront.net/"
  );
  const [videoCdnUrl, setIVideoCdnUrl] = useState(
    "https://d2d6zdxlahy4vh.cloudfront.net/"
  );
  const [shoketUrl, setShoketUrl] = useState(socketEngUrl);
  const [allCurrency, setAllCurrency] = useState([]);
  const [slectedCurrency, setSlectedCurrency] = useState({
    currency_value: "",
    currency_code: "",
    countryCode: "",
    symbol: "",
    min: "",
    hour: "",
    timeAction: "",
  });
  const [myLocation, setMyLocation] = useState();
  const [payStatus, setPayStatus] = useState(false);

  const [regPromo, setRegPromo] = useState({
    isReg: false,
    eventmode: false,
    promoMessage: {},
    phone: "",
  });

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const socket = useRef();

  useEffect(() => {
    socket.current = io(shoketUrl);
    setSocketData(socket.current);
    currency();
  }, []);

  useEffect(() => {
    window.addEventListener("beforeunload", clearLocalStorage);

    return () => {
      window.removeEventListener("beforeunload", clearLocalStorage);
    };
  }, []);

  const clearLocalStorage = (event) => {
    if (localStorage.getItem("isLoggedIn") === false) {
      if (event.currentTarget === window) {
        localStorage.clear();
      }
    }
  };

  // import ip from "ip";
  // export default function App() {
  //   const [ipAddress, setIpAddress] = useState("");

  //   useEffect(() => {
  //     setIpAddress(ip.address());
  //   }, []);
  //   return <div>ip:{ipAddress} </div>;
  // }

  /**
   * get all cerrency
   */
  const currency = async () => {
    let myIp = await publicIp();
    axios
      .get(`/api/all/currency/` + myIp)
      .then((res) => {
        if (res.data.status === 200) {
          setAllCurrency(res.data.currency);
          setSlectedCurrency({
            currency_value: res.data?.currencyDetails?.currency_value,
            currency_code: res.data?.currencyDetails?.currency_code,
            countryCode: res.data?.currencyDetails?.country_code,
            symbol: res.data?.currencyDetails?.symbol,
            min: res.data?.currencyDetails?.minute,
            hour: res.data?.currencyDetails?.hours,
            timeAction: res.data?.currencyDetails?.time_action,
          });

          const localStorageCountryCode = res.data?.locationData?.countryCode;
          if (localStorageCountryCode) {
            localStorage.setItem("countryCode", localStorageCountryCode);
          } else {
            localStorage.setItem("countryCode", "None");
          }

          setMyLocation(res.data?.locationData);
          setRegPromo({
            ...regPromo,
            eventmode: res.data?.eventMode,
            promoMessage: res.data?.promoText,
          });
        }
      })
      .catch((err) => {});
  };
  // country base payment
  const paymentCount = (valu) => {
    return (Number(slectedCurrency?.currency_value) * Number(valu)).toFixed(0);
  };

  //country base time
  const countryTime = (valu) => {
    if (slectedCurrency.timeAction != "null") {
      if (slectedCurrency.timeAction == "add") {
        return moment(valu, "HH:mm:ss")
          .add(slectedCurrency.min, "minutes")
          .add(slectedCurrency.hour, "hours")
          .format("hh:mm A");
      } else if (slectedCurrency.timeAction == "remove") {
        return moment(valu, "HH:mm:ss")
          .subtract(slectedCurrency.min, "minutes")
          .subtract(slectedCurrency.hour, "hours")
          .format("hh:mm A");
      }
    }

    return moment(valu, "HH:mm:ss").format("hh:mm A");
  };

  //country base time
  const countryTimestamp = () => {
    if (slectedCurrency.timeAction != "null") {
      if (slectedCurrency.timeAction != "add") {
        return moment(new Date())
          .add(slectedCurrency.min, "minutes")
          .add(slectedCurrency.hour, "hours")
          .format();
      } else if (slectedCurrency.timeAction != "remove") {
        return moment(new Date())
          .subtract(slectedCurrency.min, "minutes")
          .subtract(slectedCurrency.hour, "hours")
          .format();
      }
    }

    return moment(new Date()).format();
  };

  //country base time
  const countryDate = (valu) => {
    if (slectedCurrency.timeAction != "null") {
      if (slectedCurrency.timeAction == "add") {
        return moment(valu)
          .add(slectedCurrency.min, "minutes")
          .add(slectedCurrency.hour, "hours")
          .format("LL");
      } else if (slectedCurrency.timeAction == "remove") {
        return moment(valu)
          .subtract(slectedCurrency.min, "minutes")
          .subtract(slectedCurrency.hour, "hours")
          .format("LL");
      }
    }

    return moment(valu).format("LL");
  };

  //country base time
  const countryDateTime = (valu, formate) => {
    if (slectedCurrency.timeAction != "null") {
      if (slectedCurrency.timeAction == "add") {
        return moment(valu)
          .add(slectedCurrency.min, "minutes")
          .add(slectedCurrency.hour, "hours")
          .format(formate);
      } else if (slectedCurrency.timeAction == "remove") {
        return moment(valu)
          .subtract(slectedCurrency.min, "minutes")
          .subtract(slectedCurrency.hour, "hours")
          .format(formate);
      }
    }

    return moment(valu).format(formate);
  };

  const paymentCountWithSymbol = (valu) => {
    return (
      (Number(slectedCurrency?.currency_value) * Number(valu)).toFixed(0) +
      " " +
      slectedCurrency.symbol
    );
  };

  const paymentCountWithSymbolCountry = (loveReactPrices = []) => {
    if (typeof loveReactPrices != "object") {
      return loveReactPrices;
    }
    // console.log("loveReactPrices", typeof loveReactPrices, loveReactPrices);
    const element = loveReactPrices.find(
      (element) => element?.currency_code === slectedCurrency.currency_code
    );
    return element?.fee || 0;
  };

  /**
   * payment possible country base
   */
  useEffect(() => {
    if (slectedCurrency?.countryCode == myLocation?.countryCode) {
      setPayStatus(true);
    } else {
      setPayStatus(false);
    }
  }, [slectedCurrency, myLocation]);

  // stop inspect
  // document.addEventListener('contextmenu', function(e) {
  //   e.preventDefault();
  // });
  // document.onkeydown = (e) => {
  //   if (e.key == 123) {
  //       e.preventDefault();
  //   }
  //   if (e.ctrlKey && e.shiftKey && e.key == 'I') {
  //       e.preventDefault();
  //   }
  //   if (e.ctrlKey && e.shiftKey && e.key == 'C') {
  //       e.preventDefault();
  //   }
  //   if (e.ctrlKey && e.shiftKey && e.key == 'J') {
  //       e.preventDefault();
  //   }
  //   if (e.ctrlKey && e.key == 'U') {
  //       e.preventDefault();
  //   }
  // };

  //  PREVENT CLIPBOARD COPYING
  // document.addEventListener("copy", evt => {
  //   evt.clipboardData.setData("text/plain", "Copying is not allowed on this website");
  //   evt.preventDefault();
  // }, false);

  useEffect(() => {}, [slectedCurrency]);

  return (
    <>
      <serverInfo.Provider
        value={{
          imageCdnUrl,
          videoCdnUrl,
          shoketUrl,
          shurjoFrormData,
          setShurjoFrormData,
          domin,
        }}
      >
        <socketContext.Provider value={socketData}>
          <LocationContext.Provider
            value={{
              allCurrency,
              slectedCurrency,
              setSlectedCurrency,
              myLocation,
              payStatus,
              paymentCount,
              paymentCountWithSymbol,
              paymentCountWithSymbolCountry,
              countryTime,
              countryDate,
              countryDateTime,
              countryTimestamp,
              regPromo,
              setRegPromo,
            }}
          >
            {/* <Elements stripe={stripePromise}> */}
            <BrowserRouter>
              <Toaster position="top-right" />
              <Switch>
                <Route exact path="/stripe-payment" component={StripePayment} />
                <Route exact path="/video-meeting" component={VideoSdk} />
                <Route exact path="/testp" component={TestPaginate} />
                <Route
                  exact
                  path="/account-delete-request"
                  component={AccountDeleteRequest}
                />

                <Route exact path="/login" component={Login} />
                <Route exact path="/signup" component={Signup} />
                <Route exact path="/otp" component={Otp} />
                <Route exact path="/forget-password" component={Forget} />
                <Route exact path="/new-password" component={NewPassword} />
                {/* <Route exact path="/about-us" component={About} /> */}
                
                <Route exact path="/greetings-video/:videoId" component={GreetingsVideo} />
                
                <Route exact path="/share/:token" component={ShareRedirect} />

                <PrivateRoute
                  path="/profile/info"
                  exact
                  component={AccountCreate}
                />

                <Route exact path="/guest" component={Home} />
                <Route
                  exact
                  path="/marketplace/shipping"
                  component={Shipping}
                />
                <Route exact path="/videocall" component={VideoCall} />
                <Route exact path="/menu" component={Menu} />
                <PrivateRoute exact path="/surya-pay" component={SuryaPay} />
                <PrivateRoute
                  exact
                  path="/sslCommerz-pay"
                  component={SSLCommerzPay}
                />
                <PrivateRoute exact path="/ipay88-pay" component={Ipay88} />

                <Route
                  exact
                  path="/marketplace/shipping/:slug"
                  component={Shipping}
                />
                {/* <PrivateRoute exact path="/wallet" component={WalletBody} /> */}

                <Route exact path="/group/:slug" component={FanGroupBody} />

                {/* Selector */}
                <Route
                  exact
                  path="/selector-sub-category"
                  component={SubCategorySelector}
                />

                {/* NestedSelector */}
                <Route
                  exact
                  path="/selector-nested-category"
                  component={NestedSubCategoryBody}
                />

                <Route path="/tutorial" component={SliderTutorial} />
                <Route path="/packages" component={Packages} />
                <Route path="/packages-user" component={CategoryModal} />
                <Route path="/guestUser" exact component={GuestUserPage} />

                {/* profile page */}
                <PrivateRoute path="/profile" exact component={Profile} />
                <PrivateRoute
                  path="/profile/:user_id"
                  exact
                  component={UserProfile}
                />

                {/* Star profile page */}
                <Route path="/starprofile/:star_id" component={StarProfile} />

                {/* Category */}
                <Route path="/coreCategory" exact component={CoreCategory} />
                <Route path="/subCategory" exact component={SubCategory} />
                <Route path="/starselection" exact component={StarSelection} />

                {/* <Route exact path="/logo" component={HelloSuperStarDemo} /> */}

                {/* Souvenir */}
                <Route exact path="/auction/:product_id" component={Auction} />
                <Route exact path="/auction-winner/:id" component={WinnerCR7} />
                <Route
                  exact
                  path="/auction-apply/:id"
                  component={AuctionSignature}
                />
                <Route
                  exact
                  path="/auction-applied/:id"
                  component={AcquiringProduct}
                />
                <Route
                  exact
                  path="/participant-video-upload/:id"
                  component={VideoUploadAudition}
                />
                <Route
                  exact
                  path="/participant-upload/:id"
                  component={AuditionGuitar}
                />

                {/* Learning Session */}
                <Route
                  exact
                  path="/learning-session/live_stream"
                  component={LearningSessionLiveStream}
                />
                {/* Meetup Session */}
                <Route
                  exact
                  path="/meetup-session/live_stream"
                  component={LearningSessionLiveStream}
                />
                {/* live chat video call     */}
                <Route
                  exact
                  path="/live-chat/video-call"
                  component={LiveChatCall}
                />

                <Route
                  exact
                  path="/learning-session/details/:slug"
                  component={RegisterLearningDetails}
                />
                {/* Live Chat Session */}
                <Route
                  exact
                  path="/livechat/details/:slug"
                  component={LiveChatDetails}
                />

                {/* Questions And Answers */}
                <Route exact path="/qna/details/:slug" component={QnaDetails} />

                {/* Meetup Event */}
                <Route
                  exact
                  path="/meetup-event/details/:slug"
                  component={MeetupDetails}
                />
                <Route
                  exact
                  path="/greeting-registration/:greeting_id/:notification_id"
                  component={GreetingRegistration}
                />

                {/* Audition Section */}
                <Route
                  exact
                  path="/audition/registration/:slug"
                  component={AuditionDescription}
                />

                <Route
                  exact
                  path="/marketplace/invoice/:id"
                  component={PurchaseInvoice}
                />

                <Route
                  exact
                  path="/souvenir/invoice/:id"
                  component={SouvenirInvoice}
                />
                <Route exact path="/joinRoom/login" component={Joinroomlogin} />

                <Route exact path="/guest_mode" component={GuestMasterLayout} />
                <Route
                  exact
                  path="/guest_mode/:slug"
                  component={GuestMasterLayout}
                />

                {/* Master Layout With Topbar + Leftbar + Rightbar */}
                <PrivateRoute path="/" component={MasterLayout} />

                {/* Error Showing Page */}
                <Route path="/404" component={Error} />

                {/* Certificate Download */}
              </Switch>
            </BrowserRouter>
          </LocationContext.Provider>
        </socketContext.Provider>
      </serverInfo.Provider>
    </>
  );
}

export default App;
